// WARNING: Automatically generated code. Any changes to this file will be overwritten.
import { arrayToPickyDict, Dict } from '@nk/utils-lib';
import { DimContainer, DimFlagContainer } from '../types/app-dim-types';
import { EntityMonitoringTypeEntity } from './app-base-screening';
import { EntityMatchDecisionTypeEntity } from './app-base-screening';
import { ScreeningCaseReviewStatusEntity } from './app-base-screening';
import { ScreeningConfigSystemSuggestionSettingEntity } from './app-base-screening';
import { ScreeningAuditLogTypeEntity } from './app-base-screening';
import { ScreeningListCategoryEntity } from './app-base-screening';
import { ScreeningNationalIdentificationSchemaEntity } from './app-base-screening';


// screening.entity_monitoring_type.entity_monitoring_type_key
export enum EntityMonitoringTypeKey {
  alternative_beneficial_owners = 'alternative_beneficial_owners',
  beneficial_owners = 'beneficial_owners',
  company = 'company',
  extended_alternative_beneficial_owners = 'extended_alternative_beneficial_owners',
  extended_beneficial_owners = 'extended_beneficial_owners',
  other = 'other',
}

// screening.entity_monitoring_type.entity_monitoring_type_key
export class EntityMonitoringTypeDims implements DimContainer<EntityMonitoringTypeKey>, DimFlagContainer {
  public flags:
    | {
        alternative_beneficial_owners: boolean;
        beneficial_owners: boolean;
        company: boolean;
        extended_alternative_beneficial_owners: boolean;
        extended_beneficial_owners: boolean;
        other: boolean;
      }
    | Dict<boolean>;
  public dims: EntityMonitoringTypeEntity[];
  public keys: EntityMonitoringTypeKey[];

  constructor(dims: EntityMonitoringTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.entity_monitoring_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.entity_monitoring_type_key as EntityMonitoringTypeKey);
  }
}

// screening.entity_match_decision_type.entity_match_decision_type_key
export enum EntityMatchDecisionTypeKey {
  bad_match = 'bad_match',
  bad_match_dont_match_again = 'bad_match_dont_match_again',
  good_match = 'good_match',
}

// screening.entity_match_decision_type.entity_match_decision_type_key
export class EntityMatchDecisionTypeDims implements DimContainer<EntityMatchDecisionTypeKey>, DimFlagContainer {
  public flags:
    | {
        bad_match: boolean;
        bad_match_dont_match_again: boolean;
        good_match: boolean;
      }
    | Dict<boolean>;
  public dims: EntityMatchDecisionTypeEntity[];
  public keys: EntityMatchDecisionTypeKey[];

  constructor(dims: EntityMatchDecisionTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.entity_match_decision_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.entity_match_decision_type_key as EntityMatchDecisionTypeKey);
  }
}

// screening.screening_case_review_status.screening_case_review_status_key
export enum ScreeningCaseReviewStatusKey {
  complete = 'complete',
  ongoing = 'ongoing',
  pending = 'pending',
}

// screening.screening_case_review_status.screening_case_review_status_key
export class ScreeningCaseReviewStatusDims implements DimContainer<ScreeningCaseReviewStatusKey>, DimFlagContainer {
  public flags:
    | {
        complete: boolean;
        ongoing: boolean;
        pending: boolean;
      }
    | Dict<boolean>;
  public dims: ScreeningCaseReviewStatusEntity[];
  public keys: ScreeningCaseReviewStatusKey[];

  constructor(dims: ScreeningCaseReviewStatusEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.screening_case_review_status_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.screening_case_review_status_key as ScreeningCaseReviewStatusKey);
  }
}

// screening.screening_config_system_suggestion_setting.screening_config_system_suggestion_setting_key
export enum ScreeningConfigSystemSuggestionSettingKey {
  enin_calculated_beneficial_owners = 'enin_calculated_beneficial_owners',
  enin_calculated_extended_beneficial_owners = 'enin_calculated_extended_beneficial_owners',
}

// screening.screening_config_system_suggestion_setting.screening_config_system_suggestion_setting_key
export class ScreeningConfigSystemSuggestionSettingDims implements DimContainer<ScreeningConfigSystemSuggestionSettingKey>, DimFlagContainer {
  public flags:
    | {
        enin_calculated_beneficial_owners: boolean;
        enin_calculated_extended_beneficial_owners: boolean;
      }
    | Dict<boolean>;
  public dims: ScreeningConfigSystemSuggestionSettingEntity[];
  public keys: ScreeningConfigSystemSuggestionSettingKey[];

  constructor(dims: ScreeningConfigSystemSuggestionSettingEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.screening_config_system_suggestion_setting_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.screening_config_system_suggestion_setting_key as ScreeningConfigSystemSuggestionSettingKey);
  }
}

// screening.screening_audit_log_type.screening_audit_log_type_key
export enum ScreeningAuditLogTypeKey {
  customer_person = 'customer_person',
  customer_person_batch_post = 'customer_person_batch_post',
  customer_person_location_post = 'customer_person_location_post',
  customer_person_national_identification_post = 'customer_person_national_identification_post',
  customer_person_post = 'customer_person_post',
  entity_monitoring = 'entity_monitoring',
  entity_monitoring_composite_post = 'entity_monitoring_composite_post',
  entity_monitoring_decision_post = 'entity_monitoring_decision_post',
  grid_inquiry = 'grid_inquiry',
  grid_inquiry_update_delete = 'grid_inquiry_update_delete',
  grid_inquiry_update_delete_failed = 'grid_inquiry_update_delete_failed',
  grid_inquiry_update_insert = 'grid_inquiry_update_insert',
  grid_inquiry_update_insert_failed = 'grid_inquiry_update_insert_failed',
  grid_inquiry_update_patch = 'grid_inquiry_update_patch',
  grid_inquiry_update_patch_failed = 'grid_inquiry_update_patch_failed',
  monitoring_origin_entity_post = 'monitoring_origin_entity_post',
  monitoring_origin_entity_upsert = 'monitoring_origin_entity_upsert',
  nightly_task = 'nightly_task',
  nightly_task_beneficial_ownership_match_failed = 'nightly_task_beneficial_ownership_match_failed',
  nightly_task_beneficial_ownership_match_finished = 'nightly_task_beneficial_ownership_match_finished',
  nightly_task_beneficial_ownership_match_started = 'nightly_task_beneficial_ownership_match_started',
  nightly_task_entity_monitoring_bulk_decision_failed = 'nightly_task_entity_monitoring_bulk_decision_failed',
  nightly_task_entity_monitoring_bulk_decision_finished = 'nightly_task_entity_monitoring_bulk_decision_finished',
  nightly_task_entity_monitoring_bulk_decision_started = 'nightly_task_entity_monitoring_bulk_decision_started',
  nightly_task_entity_monitoring_update = 'nightly_task_entity_monitoring_update',
  nightly_task_grid_sync_grid_alerts_failed = 'nightly_task_grid_sync_grid_alerts_failed',
  nightly_task_grid_sync_grid_alerts_finished = 'nightly_task_grid_sync_grid_alerts_finished',
  nightly_task_grid_sync_grid_alerts_started = 'nightly_task_grid_sync_grid_alerts_started',
  nightly_task_grid_sync_grid_inquiries_failed = 'nightly_task_grid_sync_grid_inquiries_failed',
  nightly_task_grid_sync_grid_inquiries_finished = 'nightly_task_grid_sync_grid_inquiries_finished',
  nightly_task_grid_sync_grid_inquiries_started = 'nightly_task_grid_sync_grid_inquiries_started',
  nightly_task_regenerate_grid_entities_from_grid_alert = 'nightly_task_regenerate_grid_entities_from_grid_alert',
  nightly_task_screening_action_bulk_decision_failed = 'nightly_task_screening_action_bulk_decision_failed',
  nightly_task_screening_action_bulk_decision_finished = 'nightly_task_screening_action_bulk_decision_finished',
  nightly_task_screening_action_bulk_decision_started = 'nightly_task_screening_action_bulk_decision_started',
  screening_action_composite_post = 'screening_action_composite_post',
  screening_action_patch = 'screening_action_patch',
  screening_action_post = 'screening_action_post',
  screening_case = 'screening_case',
  screening_case_patch = 'screening_case_patch',
  screening_case_review_patch = 'screening_case_review_patch',
  screening_case_review_patch_complete = 'screening_case_review_patch_complete',
  screening_case_review_patch_ongoing = 'screening_case_review_patch_ongoing',
  screening_case_review_patch_pending = 'screening_case_review_patch_pending',
  screening_case_review_post = 'screening_case_review_post',
  screening_case_review_post_complete = 'screening_case_review_post_complete',
  screening_case_review_post_ongoing = 'screening_case_review_post_ongoing',
  screening_case_review_post_pending = 'screening_case_review_post_pending',
  screening_config = 'screening_config',
  screening_config_patch = 'screening_config_patch',
  screening_config_post = 'screening_config_post',
  screening_config_screening_list_category_delete = 'screening_config_screening_list_category_delete',
  screening_config_screening_list_category_post = 'screening_config_screening_list_category_post',
  screening_config_watchlist_delete = 'screening_config_watchlist_delete',
  screening_config_watchlist_post = 'screening_config_watchlist_post',
  screening_entity_post = 'screening_entity_post',
  watchlist = 'watchlist',
  watchlist_company_delete = 'watchlist_company_delete',
  watchlist_company_post = 'watchlist_company_post',
}

// screening.screening_audit_log_type.screening_audit_log_type_key
export class ScreeningAuditLogTypeDims implements DimContainer<ScreeningAuditLogTypeKey>, DimFlagContainer {
  public flags:
    | {
        customer_person: boolean;
        customer_person_batch_post: boolean;
        customer_person_location_post: boolean;
        customer_person_national_identification_post: boolean;
        customer_person_post: boolean;
        entity_monitoring: boolean;
        entity_monitoring_composite_post: boolean;
        entity_monitoring_decision_post: boolean;
        grid_inquiry: boolean;
        grid_inquiry_update_delete: boolean;
        grid_inquiry_update_delete_failed: boolean;
        grid_inquiry_update_insert: boolean;
        grid_inquiry_update_insert_failed: boolean;
        grid_inquiry_update_patch: boolean;
        grid_inquiry_update_patch_failed: boolean;
        monitoring_origin_entity_post: boolean;
        monitoring_origin_entity_upsert: boolean;
        nightly_task: boolean;
        nightly_task_beneficial_ownership_match_failed: boolean;
        nightly_task_beneficial_ownership_match_finished: boolean;
        nightly_task_beneficial_ownership_match_started: boolean;
        nightly_task_entity_monitoring_bulk_decision_failed: boolean;
        nightly_task_entity_monitoring_bulk_decision_finished: boolean;
        nightly_task_entity_monitoring_bulk_decision_started: boolean;
        nightly_task_entity_monitoring_update: boolean;
        nightly_task_grid_sync_grid_alerts_failed: boolean;
        nightly_task_grid_sync_grid_alerts_finished: boolean;
        nightly_task_grid_sync_grid_alerts_started: boolean;
        nightly_task_grid_sync_grid_inquiries_failed: boolean;
        nightly_task_grid_sync_grid_inquiries_finished: boolean;
        nightly_task_grid_sync_grid_inquiries_started: boolean;
        nightly_task_regenerate_grid_entities_from_grid_alert: boolean;
        nightly_task_screening_action_bulk_decision_failed: boolean;
        nightly_task_screening_action_bulk_decision_finished: boolean;
        nightly_task_screening_action_bulk_decision_started: boolean;
        screening_action_composite_post: boolean;
        screening_action_patch: boolean;
        screening_action_post: boolean;
        screening_case: boolean;
        screening_case_patch: boolean;
        screening_case_review_patch: boolean;
        screening_case_review_patch_complete: boolean;
        screening_case_review_patch_ongoing: boolean;
        screening_case_review_patch_pending: boolean;
        screening_case_review_post: boolean;
        screening_case_review_post_complete: boolean;
        screening_case_review_post_ongoing: boolean;
        screening_case_review_post_pending: boolean;
        screening_config: boolean;
        screening_config_patch: boolean;
        screening_config_post: boolean;
        screening_config_screening_list_category_delete: boolean;
        screening_config_screening_list_category_post: boolean;
        screening_config_watchlist_delete: boolean;
        screening_config_watchlist_post: boolean;
        screening_entity_post: boolean;
        watchlist: boolean;
        watchlist_company_delete: boolean;
        watchlist_company_post: boolean;
      }
    | Dict<boolean>;
  public dims: ScreeningAuditLogTypeEntity[];
  public keys: ScreeningAuditLogTypeKey[];

  constructor(dims: ScreeningAuditLogTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.screening_audit_log_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.screening_audit_log_type_key as ScreeningAuditLogTypeKey);
  }
}

// screening.screening_list_category.screening_list_category_key
export enum ScreeningListCategoryKey {
  eu = 'eu',
  hmt = 'hmt',
  ofac = 'ofac',
  other = 'other',
  un = 'un',
  uncategorized = 'uncategorized',
  usa = 'usa',
}

// screening.screening_list_category.screening_list_category_key
export class ScreeningListCategoryDims implements DimContainer<ScreeningListCategoryKey>, DimFlagContainer {
  public flags:
    | {
        eu: boolean;
        hmt: boolean;
        ofac: boolean;
        other: boolean;
        un: boolean;
        uncategorized: boolean;
        usa: boolean;
      }
    | Dict<boolean>;
  public dims: ScreeningListCategoryEntity[];
  public keys: ScreeningListCategoryKey[];

  constructor(dims: ScreeningListCategoryEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.screening_list_category_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.screening_list_category_key as ScreeningListCategoryKey);
  }
}

// screening.screening_national_identification_schema.national_identification_schema
export enum ScreeningNationalIdentificationSchemaKey {
  DK = 'DK',
  FI = 'FI',
  NO = 'NO',
  SE = 'SE',
}

// screening.screening_national_identification_schema.national_identification_schema
export class ScreeningNationalIdentificationSchemaDims implements DimContainer<ScreeningNationalIdentificationSchemaKey>, DimFlagContainer {
  public flags:
    | {
        DK: boolean;
        FI: boolean;
        NO: boolean;
        SE: boolean;
      }
    | Dict<boolean>;
  public dims: ScreeningNationalIdentificationSchemaEntity[];
  public keys: ScreeningNationalIdentificationSchemaKey[];

  constructor(dims: ScreeningNationalIdentificationSchemaEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.national_identification_schema,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.national_identification_schema as ScreeningNationalIdentificationSchemaKey);
  }
}
